import type { TranslationMessages } from './types';

export const assistant: TranslationMessages = {
  title: 'Trợ lý ảo',
  description: 'Hỏi tôi bất cứ điều gì về hoạt động cửa hàng của bạn',
  startConversation: 'Bắt đầu cuộc trò chuyện với trợ lý của bạn',
  helpMessage:
    'Tôi có thể giúp bạn tạo đơn hàng, quản lý kho, trả lời câu hỏi và nhiều hơn nữa!',
  inputPlaceholder: 'Nhập tin nhắn của bạn... (Nhấn Enter để gửi)',
  captureScreenshot: 'Chụp màn hình',
  clearHistory: 'Xóa lịch sử trò chuyện',
  clearHistoryConfirm: 'Bạn có chắc chắn muốn xóa lịch sử trò chuyện không?',
  encryptHistory: 'Mã hóa lịch sử trò chuyện (cho máy tính công cộng)',
  errorMessage:
    'Xin lỗi, tôi đã gặp lỗi. Vui lòng thử lại hoặc liên hệ hỗ trợ.',
  approve: 'Chấp nhận',
  reject: 'Từ chối',
  suggestions: {
    createOrder: 'Tạo đơn hàng',
    createProduct: 'Tạo sản phẩm',
    viewInventory: 'Xem tồn kho',
    help: 'Bạn có thể giúp gì?',
  },
  orderItems: 'Sản phẩm',
  customer: 'Khách hàng',
};
